import React, { Fragment, useEffect } from "react";
import { Spin } from "antd";

import { useHospitalMappingStore } from "@stores/useHospitalMappingStore";

import HospitalListCMService from "@services/hospital-list-and-case-manager.service";

import TableComponent from "../table/table";
import Icon from "@assets/icon_config";
import { tabKeyName } from "../FacilityInfo/FacilityInfo";
import HopitalListAddAndUpdateModal from "../modal/modal";
import "../hospitalMapping.scss";
import HealthemSpinner from "@components/healthemSpinner/healthemSpinner";
import { CanEdit } from '@components/accessLevel'

const CaseManagerListTable = (props: any) => {
  const primaryKey = "hosplst_casemgr_name";
  const HOSPITAL_LIST_TAB_NAME = "Hospital Case Manager";

  const setIsAddTableRowModalOpen = useHospitalMappingStore((state) => state.setIsAddTableRowModalOpen);
  const currentpageMode = useHospitalMappingStore((state) => state.pageCurrentMode);
  const setModalData = useHospitalMappingStore((state) => state.setModalData);
  const activeTab = useHospitalMappingStore((state) => state.activeTab);
  const setModalMode = useHospitalMappingStore((state) => state.setModalMode);
  const isHospitalListLoading = useHospitalMappingStore((state) => state.isHospitalListLoading);
  const isHospitalListTabColumnConfigLoaded = useHospitalMappingStore((state) => state.isHospitalListTabColumnConfigLoaded);

  useEffect(() => {
    console.log("CaseManagerListTable.useEffect");
    if (tabKeyName.hospitalCaseManager === activeTab) {
      setModalData({
        title: "Hospital Case Manager",
        data: props.data,
        columnData: props.column,
        rowData: [],
      });
      setModalMode("add");
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeTab]);

  const softDeleteRow = (record: any) => {
    if (currentpageMode === "edit") {
      let body = {
        facilityName: record.facility_name,
        caseManagerName: record.hosplst_casemgr_name,
        isDelete: record.is_active === "Y" ? true : false,
      };

      HospitalListCMService.editHospitalMapping(HOSPITAL_LIST_TAB_NAME, body).subscribe({
        next: (v) => {
          let temp = props.data.map((opt: any) => {
            let temp1 = { ...opt };
            if (record[primaryKey] === opt[primaryKey] && record?.hosplst_casemgr_phone_num === opt?.hosplst_casemgr_phone_num) {
              temp1 = {
                ...temp1,
                is_active: record.is_active === "Y" ? "N" : "Y",
              };
            }
            return temp1;
          });
          props.setData(temp);
        },
        error: (e) => {
          console.log(e);
        },
      });
    }
  };

  const rowDataUpdate = (record: any) => {
    props.setData([
      ...props.data.map((caseManager: any) => {
        let tempCaseManager: any = caseManager;
        if (caseManager.hosplst_casemgr_name === record.caseManagerName) {
          tempCaseManager = {
            ...tempCaseManager,
            hosplst_casemgr_email_id: record.caseManagerMail,
            hosplst_casemgr_fax_num: record.caseManagerFax,
            hosplst_casemgr_name: record.newCaseManagerName,
            hosplst_casemgr_phone_num: record.caseManagerPhone,
          };
        }
        return tempCaseManager;
      }),
    ]);
  };

  const Add_new_row = (record: any) => {
    let tempHospitalObject = {
      facility_name: record.facilityName,
      hosplst_casemgr_email_id: record.caseManagerMail,
      hosplst_casemgr_fax_num: record.caseManagerFax,
      hosplst_casemgr_name: record.caseManagerName,
      hosplst_casemgr_phone_num: record.caseManagerPhone,
      is_active: "Y",
    };
    props.setData([...props.data, tempHospitalObject]);
  };

  // const validateCaseManagerName = (inputText:string) => {
  //   let validatedText = true;
  //   forEach( props.data , (caseManager:any) => {
  //     if(caseManager?.hosplst_casemgr_name?.trim().toLowerCase() === inputText?.trim()?.toLowerCase())
  //       validatedText = false;
  //   })
  //   return {
  //     validation : validatedText,
  //     error_message : "Hospital Case Manager Already Exists.!",
  //   };
  // }

  return (
    <div>
      {isHospitalListLoading || isHospitalListTabColumnConfigLoaded ? (
        <div className="hospital-cm-report-loader">
          <Spin size="large" className="hospital-cm-report-loader__spinner" indicator={<HealthemSpinner/>}/>
        </div>
      ) : (
        <Fragment>
          <div className="HospitalList-And-CM-TableComponent">
          <TableComponent column={props.column} data={props.data} setData={props.setData} primaryKey={primaryKey} tab={HOSPITAL_LIST_TAB_NAME} delete={softDeleteRow} />
          {currentpageMode === "edit" ? (
            <CanEdit>
            <div
              className="HospitalList-And-CM-TableComponent__add-row"
              onClick={() => {
                setIsAddTableRowModalOpen(true);
                setModalMode("add");
              }}
            >
              <div className="HospitalList-And-CM-TableComponent__add-row__icon">
                <Icon name="addFacility" />
              </div>
              <div className="HospitalList-And-CM-TableComponent__add-row__title">Add Hospital Case Manager</div>
            </div>
            </CanEdit>
          ) : null}
          </div>
          <HopitalListAddAndUpdateModal data={props.data} setData={props.setCaseManagerListState} updateRow={rowDataUpdate} addRow={Add_new_row} hospitalData={ props.hospitalData } caseManagerData ={ props.caseManagerData } payorCaseManager = {props.payorCaseManager} hospitalSetData={props.hospitalSetData} caseManagerSetData={props.caseManagerSetData} payorCaseManagerSetData={props.payorCaseManagerSetData}/>
        </Fragment>
      )}
    </div>
  );
};

export default CaseManagerListTable;
